/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './pharmacy-external-order-shipment-item.reducer';

export const PharmacyExternalOrderShipmentItem = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const pharmacyExternalOrderShipmentItemList = useAppSelector(state => state.pharmacyExternalOrderShipmentItem.entities);
  const loading = useAppSelector(state => state.pharmacyExternalOrderShipmentItem.loading);
  const totalItems = useAppSelector(state => state.pharmacyExternalOrderShipmentItem.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="pharmacy-external-order-shipment-item-heading" data-cy="PharmacyExternalOrderShipmentItemHeading">
        <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipmentItem.home.title">
          Pharmacy External Order Shipment Items
        </Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipmentItem.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link
            to="/pharmacy-external-order-shipment-item/new"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipmentItem.home.createLabel">
              Create new Pharmacy External Order Shipment Item
            </Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.pharmacyExternalOrderShipmentItem.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {pharmacyExternalOrderShipmentItemList && pharmacyExternalOrderShipmentItemList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipmentItem.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('shippedQty')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipmentItem.shippedQty">Shipped Qty</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('shippedQty')} />
                </th>
                <th className="hand" onClick={sort('receivedQty')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipmentItem.receivedQty">Received Qty</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('receivedQty')} />
                </th>
                <th className="hand" onClick={sort('packs')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipmentItem.packs">Packs</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('packs')} />
                </th>
                <th className="hand" onClick={sort('productType')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipmentItem.productType">Product Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('productType')} />
                </th>
                <th className="hand" onClick={sort('productId')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipmentItem.productId">Product Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('productId')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipmentItem.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipmentItem.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('lastUpdated')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipmentItem.lastUpdated">Last Updated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastUpdated')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipmentItem.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('timestampEntry')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipmentItem.timestampEntry">Timestamp Entry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampEntry')} />
                </th>
                <th className="hand" onClick={sort('purchaseBillItemId')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipmentItem.purchaseBillItemId">
                    Purchase Bill Item Id
                  </Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('purchaseBillItemId')} />
                </th>
                <th className="hand" onClick={sort('freeQty')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipmentItem.freeQty">Free Qty</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('freeQty')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipmentItem.orderItem">Order Item</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipmentItem.shipment">Shipment</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {pharmacyExternalOrderShipmentItemList.map((pharmacyExternalOrderShipmentItem, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button
                      tag={Link}
                      to={`/pharmacy-external-order-shipment-item/${pharmacyExternalOrderShipmentItem.id}`}
                      color="link"
                      size="sm"
                    >
                      {pharmacyExternalOrderShipmentItem.id}
                    </Button>
                  </td>
                  <td>{pharmacyExternalOrderShipmentItem.shippedQty}</td>
                  <td>{pharmacyExternalOrderShipmentItem.receivedQty}</td>
                  <td>{pharmacyExternalOrderShipmentItem.packs}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.PharmacyProductType.${pharmacyExternalOrderShipmentItem.productType}`} />
                  </td>
                  <td>{pharmacyExternalOrderShipmentItem.productId}</td>
                  <td>{pharmacyExternalOrderShipmentItem.active ? 'true' : 'false'}</td>
                  <td>{pharmacyExternalOrderShipmentItem.cursor}</td>
                  <td>{pharmacyExternalOrderShipmentItem.lastUpdated}</td>
                  <td>{pharmacyExternalOrderShipmentItem.microSec}</td>
                  <td>{pharmacyExternalOrderShipmentItem.timestampEntry}</td>
                  <td>{pharmacyExternalOrderShipmentItem.purchaseBillItemId}</td>
                  <td>{pharmacyExternalOrderShipmentItem.freeQty}</td>
                  <td>
                    {pharmacyExternalOrderShipmentItem.orderItem ? (
                      <Link to={`/pharmacy-external-order-item/${pharmacyExternalOrderShipmentItem.orderItem.id}`}>
                        {pharmacyExternalOrderShipmentItem.orderItem.id}
                      </Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {pharmacyExternalOrderShipmentItem.shipment ? (
                      <Link to={`/pharmacy-external-order-shipment/${pharmacyExternalOrderShipmentItem.shipment.id}`}>
                        {pharmacyExternalOrderShipmentItem.shipment.id}
                      </Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/pharmacy-external-order-shipment-item/${pharmacyExternalOrderShipmentItem.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/pharmacy-external-order-shipment-item/${pharmacyExternalOrderShipmentItem.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/pharmacy-external-order-shipment-item/${pharmacyExternalOrderShipmentItem.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.pharmacyExternalOrderShipmentItem.home.notFound">
                No Pharmacy External Order Shipment Items found
              </Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={pharmacyExternalOrderShipmentItemList && pharmacyExternalOrderShipmentItemList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default PharmacyExternalOrderShipmentItem;
